export default __webpack_public_path__ + "static/media/ic_trading.4daf2a7f.svg";